// Characters that break a downstream HTML-mode renderer (Telegram alerts) or
// inject markup - stripped client-side before the request even goes out,
// mirroring the server's own validation (Botimza/server/routes/dealFollowupRoutes.js).
// The server enforces this regardless - this is just so a legitimate
// caller's data isn't silently mangled somewhere the caller can't see.
const UNSAFE_CHARS_PATTERN = /[<>]/g;

function stripUnsafeChars(value) {
  return typeof value === 'string' ? value.replace(UNSAFE_CHARS_PATTERN, '') : value;
}

/**
 * Dedicated client for the deal-followup popup's answers
 * (docs/deal-signal-design.md §9/§10). POSTs directly to
 * /api/deal-followup/answer rather than going through StatsWrapper's generic
 * /api/stats/track, since this endpoint drives a real side effect (an
 * immediate admin Telegram alert) and has its own strict, purpose-built
 * validation server-side (Botimza/server/routes/dealFollowupRoutes.js).
 *
 * Called twice per shown popup - once when step 1 (order status) is
 * answered, again when step 2 (deal quality) is answered - each call
 * carries everything known so far, so an abandoned popup after step 1
 * still gets reported.
 *
 * Fire-and-forget, same convention as StatsWrapper.track() - never await
 * this at call sites, never let a failure surface to the caller.
 * @param {Object} payload
 * @param {string} payload.asin
 * @param {string} [payload.itemName]
 * @param {string} [payload.domain]
 * @param {string} [payload.href]
 * @param {string} [payload.orderAnswer] - 'ordered' | 'declined' | 'undecided'
 * @param {string} [payload.goodDeal] - 'yes' | 'no'
 */
export function reportDealFollowupAnswer(payload) {
  try {
    fetch('/api/deal-followup/answer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ...payload, itemName: stripUnsafeChars(payload?.itemName) }),
    })?.catch(() => {});
  } catch {
    // Swallow - see StatsWrapper.js for the same reasoning (must never break
    // the popup's UI flow, even if fetch itself throws synchronously).
  }
}
